import { createGlobalStyle } from "styled-components";

export const GlobalStyle = createGlobalStyle`
  :root {
    --primary: #375A7F;
    --primary-dark: #2C4A6B;
    --secondary: #FF6B6B;
    --accent: #4ECDC4;
    --bg: #F7F9FC;
    --bg-secondary: #F0F2F5;
    --text: #1F2D3D;
    --text-secondary: #6B7280;
  }

  html, body, #root {
    height: 100%;
  }

  body {
    background: var(--bg);
    color: var(--text);
  }

  h1, h2, h3 {
    font-family: Poppins, Inter, system-ui, -apple-system, Segoe UI, Roboto, Arial, sans-serif;
    letter-spacing: -0.02em;
    margin: 0 0 8px 0;
  }

  p {
    line-height: 1.7;
    margin: 0 0 12px 0;
  }
`;
